import { useFormControl, formControlState } from '../..';
import * as Styled from './styled';

export const BaseInputLabel = (props) => {
  const contextProps = useFormControl();

  const fcs = formControlState({
    props,
    ctxProps: contextProps,
    states: ['readOnly', 'error', 'required', 'disabled'],
  });

  return (
    <Styled.InputLabel
      readOnly={fcs.readOnly}
      required={fcs.required}
      error={fcs.error}
      disabled={fcs.disabled}
      {...fcs}
      {...props}
    />
  );
};
